/* eslint-disable @angular-eslint/component-class-suffix */
import { Component } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.page.html',
  styleUrls: ['./splash-screen.page.scss'],
})
/**
 * This is the splash screen
 */
export class SplashScreenPage {}
